module.exports = __webpack_public_path__ + "static/media/11-search.5baa9854.png";